









































































import Vue from 'vue';
import _ from 'lodash';

import { statusExameStrings } from '../../utils/constants';
import { ResultadoDeExame } from '../../../../back/src/entity/ResultadoDeExame';
import { Gestacao } from '../../../../back/src/entity/Gestacao';
import { StatusExame } from '../../../../back/src/types';

import IfEmptyTextPrintNA from '../IfEmptyTextPrintNA.vue';
import { calculoIdadeGestacional } from '../../utils/functions';

export default Vue.extend({
  name: 'ResultadosDeExamesDetalhes',
  components: {
    IfEmptyTextPrintNA,
  },
  props: {
    resultadoDeExame: {
      type: null || Object as () => ResultadoDeExame,
    },
    gestacao: {
      type: null || Object as () => Gestacao,
    },
    pacienteNome: {
      type: String,
    },
  },
  data() {
    return {
      statusExameStrings,
    };
  },
  computed: {
    vRowClass(): string {
      if (this.$vuetify.breakpoint.xsOnly) {
        return 'd-flex flex-column';
      }
      return '';
    },
    vColClass(): string {
      return 'pt-1 pb-2';
    },
    idadeGestacional(): string {
      if (this.gestacao) {
        return calculoIdadeGestacional(this.gestacao, this.resultadoDeExame.data_exame, true);
      }
      return '';
    },
  },
  methods: {
    classStatus(resultado: ResultadoDeExame) {
      if (resultado.status === StatusExame.N || resultado.status === StatusExame['-']) {
        return 'success--text';
      }
      if (resultado.status === StatusExame.A || resultado.status === StatusExame['+']) {
        return 'error--text';
      }
      if (resultado.status === StatusExame.I) {
        return 'primary--text';
      }
      if (_.has(resultado, 'exame') && !!resultado.exame) {
        if (_.has(resultado.exame, 'opcoes_status') && !!resultado.exame.opcoes_status) {
          const opcao = _.find(
            resultado.exame.opcoes_status,
            item => (item.status === resultado.status),
          );
          if (opcao) {
            return `${opcao.color}--text`;
          }
          return 'primary--text';
        }
        return 'success--text';
      }
      if (resultado.status === 'Alterado') {
        return 'error--text';
      }
      return 'success--text';
    },
    getStatus(resultado: ResultadoDeExame) {
      if (resultado.status && _.has(statusExameStrings, resultado.status)) {
        return statusExameStrings[resultado.status];
      }
      return resultado.status;
    },
  },
});
